if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 750px)');
        this.header = this.closest('.header-wrapper') || document.querySelector('.header-wrapper');
        this.menuDrawer = this.closest('.menu-drawer');
        this.mobileCountryQuery = window.matchMedia('(max-width: 749px)');
        this.panelHome = null;
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button.localization-form__select'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector('.country-selector__close-button'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('[data-country-search-results]'),
        };

        if (!this.elements.button || !this.elements.panel) return;

        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
        this.addEventListener('focusout', this.closeSelector.bind(this));
        this.elements.button.addEventListener('click', this.openSelector.bind(this));

        if (this.elements.search) {
          this.elements.search.addEventListener('input', this.filterCountries.bind(this));
          this.elements.search.addEventListener('focus', this.onSearchFocus.bind(this));
          this.elements.search.addEventListener('blur', this.onSearchBlur.bind(this));
          this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
        }
        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener('click', this.resetFilter.bind(this));
          this.elements.resetButton.addEventListener('mousedown', (event) => event.preventDefault());
        }

        this.querySelectorAll('a[data-value]').forEach((item) =>
          item.addEventListener('click', this.onItemClick.bind(this))
        );
      }

      mountMobileCountryPanel() {
        if (!this.elements.search || !this.mobileCountryQuery.matches) return;
        if (this.elements.panel.classList.contains('dremis-country-panel--mobile')) return;

        this.panelHome = {
          parent: this.elements.panel.parentNode,
          nextSibling: this.elements.panel.nextSibling,
        };

        this.elements.panel.classList.add('dremis-country-panel--mobile');
        document.body.appendChild(this.elements.panel);
        document.body.classList.add('dremis-country-panel-open');
      }

      restoreMobileCountryPanel() {
        if (!this.elements.panel.classList.contains('dremis-country-panel--mobile')) return;

        this.elements.panel.classList.remove('dremis-country-panel--mobile');
        document.body.classList.remove('dremis-country-panel-open');

        if (!this.panelHome?.parent) return;
        if (this.panelHome.nextSibling && this.panelHome.nextSibling.parentNode === this.panelHome.parent) {
          this.panelHome.parent.insertBefore(this.elements.panel, this.panelHome.nextSibling);
        } else {
          this.panelHome.parent.appendChild(this.elements.panel);
        }
        this.panelHome = null;
      }

      hidePanel() {
        if (!this.elements.button || !this.elements.panel) return;
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.setAttribute('aria-activedescendant', '');
        }
        document.body.classList.remove('overflow-hidden-mobile');
        if (this.menuDrawer) this.menuDrawer.classList.remove('country-selector-open');
        this.restoreMobileCountryPanel();
        if (this.header) this.header.preventHide = false;
      }

      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.elements.panel.querySelectorAll('a[data-value]')).filter(
          (item) => !item.parentElement.classList.contains('hidden')
        );
        if (!focusableItems.length) return;

        let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case 'ARROWUP':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
            itemToFocus.focus();
            break;
          case 'ARROWDOWN':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
            itemToFocus.focus();
            break;
        }

        if (!this.elements.search) return;
        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
          this.elements.search.setAttribute(
            'aria-activedescendant',
            focusedItemIndex > -1 ? focusableItems[focusedItemIndex].id : ''
          );
        });
      }

      onContainerKeyUp(event) {
        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            if (this.elements.button.getAttribute('aria-expanded') === 'false') return;
            event.preventDefault();
            this.hidePanel();
            event.stopPropagation();
            this.elements.button.focus();
            break;
          case 'SPACE':
            if (this.elements.button.getAttribute('aria-expanded') === 'true') return;
            event.preventDefault();
            this.openSelector();
            break;
        }
      }

      onItemClick(event) {
        const item = event.currentTarget;

        // Language options have real localized URLs. Let the browser navigate
        // directly instead of creating another /localization POST + redirect state.
        if (item.dataset.localizationKind === 'language' && item.getAttribute('href') !== '#') {
          this.hidePanel();
          return;
        }

        event.preventDefault();
        const form = this.querySelector('form');
        if (!form || !this.elements.input) return;
        this.elements.input.value = item.dataset.value;
        form.requestSubmit ? form.requestSubmit() : form.submit();
      }

      openSelector() {
        const shouldOpen = this.elements.button.getAttribute('aria-expanded') === 'false';

        if (!shouldOpen) {
          this.hidePanel();
          return;
        }

        this.mountMobileCountryPanel();
        this.elements.panel.removeAttribute('hidden');
        this.elements.button.setAttribute('aria-expanded', 'true');
        if (this.elements.search) this.filterCountries();

        if (!document.body.classList.contains('overflow-hidden-tablet')) {
          document.body.classList.add('overflow-hidden-mobile');
        }
        if (this.elements.search && this.mql.matches) this.elements.search.focus();
        if (this.hasAttribute('data-prevent-hide') && this.header) this.header.preventHide = true;
        if (this.menuDrawer && this.elements.search) this.menuDrawer.classList.add('country-selector-open');
      }

      closeSelector(event) {
        if (event.relatedTarget && this.elements.panel.contains(event.relatedTarget)) return;

        if (
          event.target.classList.contains('country-selector__overlay') ||
          !this.contains(event.target) ||
          !this.contains(event.relatedTarget)
        ) {
          this.hidePanel();
        }
      }

      normalizeString(str) {
        return str.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase();
      }

      filterCountries() {
        if (!this.elements.search) return;
        const searchValue = this.normalizeString(this.elements.search.value);
        const popularCountries = this.elements.panel.querySelector('.popular-countries');
        const allCountries = this.elements.panel.querySelectorAll('a[data-localization-kind="country"]');
        let visibleCountries = 0;

        if (this.elements.resetButton) this.elements.resetButton.classList.toggle('hidden', !searchValue);
        if (popularCountries) popularCountries.classList.toggle('hidden', Boolean(searchValue));

        let englishRegionNames;
        try {
          englishRegionNames = new Intl.DisplayNames(['en'], { type: 'region' });
        } catch (error) {
          englishRegionNames = null;
        }

        allCountries.forEach((item) => {
          const country = item.querySelector('.country');
          const isoCode = item.dataset.value || '';
          const englishName = englishRegionNames?.of(isoCode) || '';
          const searchableValue = this.normalizeString(
            `${country ? country.textContent : item.textContent} ${isoCode} ${englishName}`
          );
          const isVisible = searchableValue.includes(searchValue);
          item.parentElement.classList.toggle('hidden', !isVisible);
          if (isVisible) visibleCountries += 1;
        });

        if (this.elements.liveRegion && window.accessibilityStrings?.countrySelectorSearchCount) {
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.countrySelectorSearchCount.replace(
            '[count]',
            visibleCountries
          );
        }

        const list = this.elements.panel.querySelector('.country-selector__list');
        if (list) {
          let emptyState = list.querySelector('[data-country-empty-state]');
          if (!emptyState) {
            emptyState = document.createElement('p');
            emptyState.dataset.countryEmptyState = '';
            emptyState.className = 'country-selector__empty-state';
            emptyState.textContent =
              document.documentElement.lang === 'de'
                ? 'Kein Land gefunden.'
                : 'No country found.';
            list.appendChild(emptyState);
          }
          emptyState.hidden = visibleCountries > 0;
        }

        const selector = this.elements.panel;
        if (selector) selector.scrollTop = 0;
        if (list) list.scrollTop = 0;
      }

      resetFilter(event) {
        event.stopPropagation();
        this.elements.search.value = '';
        this.filterCountries();
        this.elements.search.focus();
      }

      onSearchFocus() {
        if (this.elements.searchIcon) this.elements.searchIcon.classList.add('country-filter__search-icon--hidden');
      }

      onSearchBlur() {
        if (!this.elements.search.value && this.elements.searchIcon) {
          this.elements.searchIcon.classList.remove('country-filter__search-icon--hidden');
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === 'ENTER') event.preventDefault();
      }
    }
  );
}
